import type { ReactNode } from 'react';

interface TextCellProps {
  value: unknown;
}

/**
 * Default text cell renderer.
 *
 * Converts any value to a string for display.
 * Styled to match ux-common table cells with responsive padding and text size.
 */
export const TextCell = ({ value }: TextCellProps): ReactNode => {
  if (value === null || value === undefined) {
    return <span className="text-sm text-muted-foreground px-2.5 truncate">—</span>;
  }

  return <span className="text-sm text-foreground px-2.5 truncate">{String(value)}</span>;
};

TextCell.displayName = 'DataTable.TextCell';
